import isString from 'lodash/isString';
import { Trans, useTranslation } from 'react-i18next';

import { replaceWithRound } from './utils';

import type { FC } from 'react';
import type { TooltipContentProps } from 'shared/components/charts/BarChart';

export const TooltipContent: FC<TooltipContentProps> = ({
  x: subjectName,
  yLabel: grade,
  gradeType = 'Cumulative',
}) => {
  const { t } = useTranslation();

  if (!isString(grade)) {
    return (
      <Trans
        i18nKey="GSP.entities.cumulativeGrades.tooltipContentNoGrade"
        values={{ subjectName }}
      />
    );
  }

  return (
    <Trans
      i18nKey="GSP.entities.cumulativeGrades.tooltipContent"
      values={{
        subjectName,
        grade: replaceWithRound(grade),
        type: t(
          `GSP.entities.cumulativeGrades.tooltipContentTypes.${gradeType?.toLowerCase()}`,
        ),
      }}
    />
  );
};
